"use client";
import "../../../chunk-MMUBH76A.js";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { useModalStore, useThemeStore } from "../../stores/index.js";
import { CpslButton, CpslIdenticon, CpslText } from "@getpara/react-components";
import { truncateAddress } from "@getpara/web-sdk";
import { ModalStep } from "../../utils/steps.js";
import { useWalletState } from "../../../provider/index.js";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
const ExternalWalletCard = ({ address, showAddFunds }) => {
  var _a;
  const para = useInternalClient();
  const wallet = para.externalWallets[address];
  if (!wallet) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    SharedWalletCard,
    {
      address: (_a = wallet.ensName) != null ? _a : truncateAddress(wallet.address, wallet.type),
      identiconHash: para.getIdenticonHash(wallet.id, wallet.type),
      showAddFunds
    }
  );
};
const WalletCard = ({ id, type, showAddFunds }) => {
  var _a, _b;
  const para = useInternalClient();
  const appName = useThemeStore((state) => state.appName);
  const wallet = para.findWallet(id, type);
  if (!wallet) {
    return null;
  }
  const address = para.getDisplayAddress(wallet.id, { addressType: type });
  return /* @__PURE__ */ jsx(
    SharedWalletCard,
    {
      id: wallet.id,
      type: wallet.type,
      address: (_a = wallet.ensName) != null ? _a : truncateAddress(address, type, { prefix: para.cosmosPrefix }),
      name: (_b = wallet.name) != null ? _b : `${appName ? `${appName} ` : ""}Wallet`,
      identiconHash: para.getIdenticonHash(wallet.id, type),
      showAddFunds
    }
  );
};
const SharedWalletCard = ({ address, name, identiconHash, showAddFunds, id, type }) => {
  const onRampConfig = useModalStore((state) => state.onRampConfig);
  const { setSelectedWallet } = useWalletState();
  const setStep = useModalStore((state) => state.setStep);
  const isAddFundsEnabled = (onRampConfig == null ? void 0 : onRampConfig.isBuyEnabled) || (onRampConfig == null ? void 0 : onRampConfig.isReceiveEnabled);
  const handleAddFundsClick = () => {
    if (id && type) {
      setSelectedWallet({ id, type });
      isAddFundsEnabled && setStep(onRampConfig.isBuyEnabled ? ModalStep.ADD_FUNDS_BUY : ModalStep.ADD_FUNDS_RECEIVE);
    }
  };
  return /* @__PURE__ */ jsxs(Container, { children: [
    /* @__PURE__ */ jsxs(InnerContainer, { children: [
      /* @__PURE__ */ jsx(CpslIdenticon, { size: "48px", hash: identiconHash }),
      /* @__PURE__ */ jsxs(WalletNameContainer, { children: [
        !!name && /* @__PURE__ */ jsx(Name, { color: "contrast", variant: "bodyL", weight: "semiBold", children: name }),
        /* @__PURE__ */ jsx(Name, { color: "secondary", variant: "bodyS", weight: "medium", children: address })
      ] })
    ] }),
    showAddFunds && isAddFundsEnabled && /* @__PURE__ */ jsx(AddFundsButton, { onClick: handleAddFundsClick, children: /* @__PURE__ */ jsx(CpslText, { variant: "bodyXS", color: "contrast", weight: "medium", children: "Add Funds" }) })
  ] });
};
const WalletCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;
const Container = styled.div`
  width: 100%;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  background-color: var(--cpsl-color-background-8);
  border-radius: 16px;
`;
const InnerContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  align-items: center;
  overflow: hidden;
`;
const WalletNameContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  justify-content: center;
  overflow: hidden;
`;
const Name = styled(CpslText)`
  width: 100%;
  &::part(text-element) {
    line-height: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const AddFundsButton = styled(CpslButton)`
  --button-primary-background-color: var(--cpsl-color-card-surface);
  --button-primary-hover-background-color: var(--cpsl-color-background-4);
  --button-primary-color: var(--cpsl-color-text-contrast);
  --button-primary-hover-color: var(--cpsl-color-text-contrast);
  --button-primary-active-color: var(--cpsl-color-text-contrast);
  --button-padding-start: 8px;
  --button-padding-end: 8px;
  --button-padding-top: 8px;
  --button-padding-bottom: 8px;
  --button-border-radius: 8px;
`;
export {
  ExternalWalletCard,
  WalletCard,
  WalletCards
};
